import Actions from './Actions';
import AdminService from '../../services/AdminService';

const adminService = new AdminService();

const getUserById = (id) => {
    return (dispatch) => {

        dispatch({type: Actions.USER_MGT_REQUEST});

        adminService.getUserById(id, (err, userResult) => {
            if (err) {
                console.debug(err);
                dispatch({
                    type: Actions.USER_MGT_FAIL,
                    message: "No data found"
                });
            } else {

                let groups = [];
                let data = userResult.data;

                if (data.status === 200) {
                    if (data.Groups === undefined) {
                        dispatch({
                            type: Actions.USER_MGT_SUCCESS,
                            payload: data,
                            groups: groups
                        });
                    } else {
                        console.debug(data.Groups);

                        for (var i = 0; i < data.Groups.length; i++) {
                            groups.push(data.Groups[i]['GroupName'])
                        }

                        dispatch({
                            type: Actions.USER_MGT_SUCCESS,
                            payload: data,
                            groups: groups
                        });
                    }
                } else {
                    console.debug(userResult);
                    dispatch({
                        type: Actions.USER_MGT_FAIL,
                        message: "No data found"
                    });
                }
            }
        });
    };
};

const userStateChange = (id, option) => {
    return (dispatch) => {
        dispatch({type: Actions.USER_STATE_CHG_REQUEST});

        let msg = option === 0 ? "User Disable" : "User Enable";

        adminService.userStateChange(id, option, (err, res) => {
            if (res.status === 200) {
                dispatch({type: Actions.USER_MGT_REQUEST});

                adminService.getUserById(id, (err, userResult) => {
                    if (err) {
                        console.debug(err);
                        dispatch({
                            type: Actions.USER_MGT_FAIL,
                            message: "No data found"
                        });
                    } else {

                        let groups = [];
                        let data = userResult.data;

                        if (data.status === 200) {
                            if (data.Groups === undefined) {
                                dispatch({
                                    type: Actions.USER_MGT_SUCCESS,
                                    payload: data,
                                    groups: groups
                                });
                            } else {
                                console.debug(data.Groups);

                                for (var i = 0; i < data.Groups.length; i++) {
                                    groups.push(data.Groups[i]['GroupName'])
                                }

                                dispatch({
                                    type: Actions.USER_MGT_SUCCESS,
                                    payload: data,
                                    groups: groups
                                });
                            }
                        } else {
                            console.debug(userResult);
                            dispatch({
                                type: Actions.USER_MGT_FAIL,
                                message: "No data found"
                            });
                        }
                    }
                });

                dispatch({
                    type: Actions.USER_STATE_CHG_SUCCESS,
                    message: msg + " Success.",
                    user: id
                });
            } else {
                dispatch({
                    type: Actions.USER_STATE_CHG_FAIL,
                    message: msg + " Fail."
                });
            }
        });

    };
};

const userAttributeChange = (id, attList) => {
    return (dispatch) => {
        dispatch({type: Actions.USER_ATTR_CHG_REQUEST});

        adminService.userAttributeChange(id, attList, (err, res) =>{
           if (err){
               console.debug(err);
               dispatch({
                   type: Actions.USER_ATTR_CHG_FAIL,
                   message: "User Attribute update fail."
               });
           }  else {
               if (res.data.status === 200){

                   dispatch({type: Actions.USER_MGT_REQUEST});

                   adminService.getUserById(id, (err, userResult) => {
                       if (err) {
                           console.debug(err);
                           dispatch({
                               type: Actions.USER_MGT_FAIL,
                               message: "No data found"
                           });
                       } else {

                           let groups = [];
                           let data = userResult.data;

                           if (data.status === 200) {
                               if (data.Groups === undefined) {
                                   dispatch({
                                       type: Actions.USER_MGT_SUCCESS,
                                       payload: data,
                                       groups: groups
                                   });
                               } else {
                                   console.debug(data.Groups);

                                   for (var i = 0; i < data.Groups.length; i++) {
                                       groups.push(data.Groups[i]['GroupName'])
                                   }

                                   dispatch({
                                       type: Actions.USER_MGT_SUCCESS,
                                       payload: data,
                                       groups: groups
                                   });
                               }
                           } else {
                               console.debug(userResult);
                               dispatch({
                                   type: Actions.USER_MGT_FAIL,
                                   message: "No data found"
                               });
                           }
                       }
                   });

                   dispatch({
                       type: Actions.USER_ATTR_CHG_SUCCESS,
                       message: "User Attribute update success."
                   });
               } else {
                   dispatch({
                       type: Actions.USER_ATTR_CHG_FAIL,
                       message: "User Attribute update fail."
                   });
               }
           }
        });

    };
};

export {getUserById, userStateChange, userAttributeChange};